import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { DeletionDialogComponent } from 'src/app/layout/deletion-dialog/deletion-dialog.component';
import { SnackbarService } from 'src/app/layout/snackbars/snackbar.service';
import { SpinnerService } from 'src/app/layout/spinner.service';
import { Detail, Request } from '../request.model';
import { RequestsService } from '../requests.service';
import { AssignDialogComponent } from '../assign-dialog/assign-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTabGroup } from '@angular/material/tabs';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'not-assigned-messages',
    templateUrl: './not-assigned.component.html',
    styleUrls: ['./not-assigned.component.scss'],
    imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIconButton, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, DatePipe]
})
export class NotAssignedComponent implements OnInit, AfterViewInit {
  constructor(
    private requestService: RequestsService,
    private snackbarService: SnackbarService,
    private dialog: MatDialog,
    private spinnerService: SpinnerService
  ) { }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) messagePaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  @Output()
  tabChange = new EventEmitter<any>();
  @Output()
  requestDeleted = new EventEmitter<any>();
  @Output()
  archivedRequest = new EventEmitter<any>();

  displayedColumns: string[] = [
    'arrow',
    'requestId',
    'customerInfo',
    'requestStatus',
    'destination',
    'packageInfo',
    'viewDetails',
    'actions',
  ];
  tabledata: Request[] = [];
  dataSource = new MatTableDataSource();

  collapsedTable: {
    id: number;
    open: boolean;
  };

  displayedDetailColumns: string[] = [
    'sendDate',
    'receivedDate',
    'receivedFrom',
    'sendTo',
    'subject'  ];

  detailData: Detail | null;

  notAssigned = false;
  displayedMessageColumns: string[] = ['actions', 'from', 'sendTo', 'date', 'subject'];
  messageTableData: Message[] = [];
  messageDataSource = new MatTableDataSource();

  dialogConfig = new MatDialogConfig();

  pageSizeOptions: any[] = [10, 20, 50, 100, 500];
  pageSize = this.pageSizeOptions[0];
  orderBy = 'id';
  sortDirection = 'desc';
  searchSubscription: Subscription;
  resultsLength = 0;



  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.refresh();
  }

  refresh(){
    this.fetchMessages();
  }

  pageChangeEvent(event): void {
    this.pageSize = event.pageSize;
  }

  // -- messages --
  deleteMessage(message: Message, index: number): void {
    const dialogRef = this.dialog.open(
      DeletionDialogComponent,
      this.dialogConfig
    );

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.spinnerService.startSpinner();
        this.requestService.deleteMessage(message.id).subscribe(
          () => {
            this.snackbarService.openSuccess();
            this.spinnerService.stopSpinner();
            this.fetchMessages();
          },
          (error: any) => {
            this.spinnerService.stopSpinner();
            this.snackbarService.openError(error.status);
          }
        );
      }
    });
  }

  openLinkMessage(message: Message): void {
    const dialogRef = this.dialog.open(AssignDialogComponent, {
      maxHeight: '600px',
      maxWidth: '800px',
      data: {
        message,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.fetchMessages();
    });
  }

  fetchMessages(): void {
    this.spinnerService.startSpinner();
    this.requestService.getNotAssignedMessages().subscribe(
      (data: Message[]) => {
        this.messageTableData = data;
        this.messageDataSource = new MatTableDataSource(this.messageTableData);
        this.messageDataSource.paginator = this.messagePaginator;
        this.spinnerService.stopSpinner();
      },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      }
    );
  }

}

interface Message {
  id?: string;
  nodes?: any[];
  meaning?: string;
  description?: string;
}
